import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Universe } from './universe.model';

@Injectable()
export class UniverseService {
    resourceUrl = '/api/universes';

    constructor(private http: HttpClient) {}

    create(universe): Observable<Universe> {
        return this.http.post<Universe>('api/universes/', universe);
    }

    update(universe): Observable<Universe[]> {
        return this.http
            .put<Universe[]>('/api/universes/' + universe.id, universe)
            .pipe(
                catchError((error: any) =>
                    observableThrowError(error.message || 'Server error')
                )
            );
    }

    remove(universe): Observable<Universe> {
        return this.http.delete<Universe>('api/universes/' + universe.id);
    }

    findAll(): Observable<Universe[]> {
        return this.http.get<Universe[]>('/api/universes');
    }

    findById(id): Observable<Universe> {
        return this.http.get<Universe>('/api/universes/' + id);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/universe/universe.service.ts